exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".usstate{width:33.33%;display:inline-block;text-align:center;vertical-align:top}.usstate img,.usstate svg{width:50%}.usstate .label{font-weight:700;text-transform:uppercase;font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;white-space:nowrap;white-space:pre}.item span{font-size:.9em;line-height:1.125em;display:inline-block;color:rgba(0,0,0,.6)}.st0{fill:none;stroke:#777;stroke-width:1.5}.dem .st0,.usstate .dem .circle{fill:#0e6eb8;stroke:none;color:#0e6eb8}.gop .st0,.usstate .gop .circle{fill:#db2828;stroke:none;color:#db2828}.usstate .circle{color:#767676;font-size:1em}.likely .st0,.likely i.icon{opacity:.6}.leaning .st0,.leaning i.icon{opacity:.2}@media (max-width:400px){.usstate .label{font-size:.9rem}}@media (max-width:535px){.item span{margin:3px 3px 0;display:block}}@media (max-width:767px){.ui.container{margin-left:0!important;margin-right:0!important}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./src/components/battlestates/Battlestates.css
 ** module id = 164
 ** module chunks = 0
 **/